import MobileHeaderActionsTab from './MobileHeaderActionsTab';
import MobileBottomNavTab from './MobileBottomNavTab';

export default function MobileShortcutsTab() {
  return (
    <div className="space-y-6">
      <MobileHeaderActionsTab />
      <MobileBottomNavTab />
    </div>
  );
}
